// src/firebase.js
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getAnalytics } from "firebase/analytics";

// Your Firebase configuration
// Replace these values with your actual Firebase project config
const firebaseConfig = {
  apiKey: "AIzaSyDcaCkRL_Jadr34BbESrOP9XPCrpPq2l78",
  authDomain: "cinder-33f58.firebaseapp.com",
  projectId: "cinder-33f58",
  storageBucket: "cinder-33f58.firebasestorage.app",
  messagingSenderId: "486079056615",
  appId: "1:486079056615:web:e7836cf3bf3a74cfe47042",
  measurementId: "G-VRSBVK8P58"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
export const auth = getAuth(app);
export default app;